import { SDKOptions, SportTypes } from '../../types';
import { encodeBase64 } from '@sportal365/smp-widget-utils/src/general';
import { generateRequest } from '../http.service';

interface IPlayoffConfigurationObj {
  apiUrl: string;
  authorization: string;
  project: string;
  language?: string;
  stage_id?: string;
}

interface IPlayoffConfigArguments {
  apiUrl: string;
  authorization: string;
  project: string;
  language?: string;
}

export interface IPlayoffDataArguments {
  stage_id?: string;
  translation_language?: string;
}

const generatePlayoffConfigArguments = (SDKconfig: SDKOptions): IPlayoffConfigArguments => {
  return {
    apiUrl: SDKconfig.dataConfigPlayoffApiUrl ? SDKconfig.dataConfigPlayoffApiUrl : '',
    authorization: `Basic ${encodeBase64(SDKconfig.dataConfigApiKey)}`,
    project: SDKconfig.dataConfigProject,
    language: SDKconfig.dataConfigLang,
  };
};

const generatePlayoffDataArguments = (playoffDataArguments: IPlayoffDataArguments) => {
  const result = {} as IPlayoffDataArguments;
  if (!playoffDataArguments || !playoffDataArguments.stage_id) {
    return result;
  }

  const stageId = playoffDataArguments.stage_id;

  if (stageId) {
    result['stage_id'] = playoffDataArguments.stage_id;
  }

  if (playoffDataArguments.translation_language) {
    result['translation_language'] = playoffDataArguments.translation_language;
  }

  return result as IPlayoffDataArguments;
};

const generatePlayoffRequestParams = (
  playoffConfigArgs: IPlayoffConfigArguments | null,
  playoffDataArgs: IPlayoffDataArguments,
): IPlayoffConfigurationObj => {
  return {
    apiUrl: playoffConfigArgs?.apiUrl || '',
    authorization: playoffConfigArgs?.authorization || '',
    project: playoffConfigArgs?.project || '',
    language: playoffConfigArgs?.language || '',
    stage_id: playoffDataArgs.stage_id,
  };
};

interface IGetPlayoff {
  params: IPlayoffDataArguments;
  sdkOptions: SDKOptions;
  sport: SportTypes;
}

export const getPlayoffs = async ({ params, sdkOptions, sport }: IGetPlayoff) => {
  const baseParams = { ...params, translation_language: sdkOptions.dataConfigLang };
  const playoffConfigArguments = generatePlayoffConfigArguments(sdkOptions);
  const playoffDataArguments = generatePlayoffDataArguments(baseParams);
  const dataForSending: IPlayoffConfigurationObj = generatePlayoffRequestParams(playoffConfigArguments, playoffDataArguments);
  return await generateRequest(`${dataForSending.apiUrl}/${sport}`, playoffDataArguments, sdkOptions);
};
